// extracted by mini-css-extract-plugin
module.exports = {"title":"AppFooter_title__mLC2J","racing":"AppFooter_racing__tHj2D","football":"AppFooter_football__6QPok"};